<section
    style="display: grid; gap: 2rem; max-width: 1080px;"
    [style.grid-template-columns]="'repeat(' + (attributes.columns || 1) + ', 1fr)'"
>
    <ng-container *ngFor="let item of attributes.images">
        <img [alt]="item" [src]="getImageURL(item)" style="display: block; width: 100%; height: auto;" />
    </ng-container>
</section>